import EffectiveUserSettings from 'relevant-shared/misc/effectiveUserSettings';

const NUMBER_FORMATS = {
	int: {
		style: 'decimal',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	},
	float: {
		style: 'decimal',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	},
};

const formatterCache = {};

const getOrCreateFormatter = (type, locale) => {
	const key = `${type}_${locale}`;
	if (!formatterCache[key]) {
		formatterCache[key] = new Intl.NumberFormat(locale ?? undefined, NUMBER_FORMATS[type]);
	}
	return formatterCache[key];
};

export const fmtNum = (number) => {
	if (number === 0) {
		return 0;
	}
	const { numberFormatLocale: locale } = EffectiveUserSettings.current();
	if (Math.round(number) === number) {
		return getOrCreateFormatter('int', locale).format(number);
	}
	return getOrCreateFormatter('float', locale).format(number);
};

export const fmtNumCsv = (number) => number.toFixed(2);

const cashFormatter = Intl.NumberFormat('en-EN', {
	notation: 'compact',
	maximumFractionDigits: 0, // For large numbers, no decimal places
});

const cashFormatterSmall = Intl.NumberFormat('en-EN', {
	notation: 'compact',
	maximumFractionDigits: 3,
});

export const formatCash = (n) => {
	// Use cashFormatterSmall for small numbers and values that need decimals (e.g., less than 1)
	if (Math.abs(n) < 1) {
		return cashFormatterSmall.format(n);
	}
	// Otherwise, use the regular formatter
	return cashFormatter.format(n);
};
